import React from "react";
import resume from "../Assets/resume.pdf";

// Define data for skills, experience, and education sections
const skillsData = [
  {
    category: "Programming Languages",
    skills: ["Python", "Java"],
  },
  {
    category: "Front-End Technologies",
    skills: [
      "React.js",
      "Next.js",
      "Redux",
      "GraphQL",
      "RESTful APIs",
      "AJAX",
      "Tailwind CSS",
      "Bootstrap",
      "HTML5",
      "CSS3",
      "JSON",
      "JavaScript (ES6)",
      "Typescript",
    ],
  },
  {
    category: "Back-End Technologies",
    skills: [
      "Node.js",
      "Express.js",
      "Spring Boot",
      "RDBMS (SQL)",
      "NoSQL (MongoDB)",
      "Redis",
    ],
  },
  {
    category: "Methodologies",
    skills: ["Agile (SCRUM)", "TDD"],
  },
  {
    category: "Tools",
    skills: [
      "Git",
      "GitHub Actions",
      "Jenkins",
      "Firebase",
      "Webpack",
      "Microsoft Office",
      "VS Code",
      "Eclipse",
    ],
  },
  {
    category: "Cloud Technologies",
    skills: ["AWS", "Docker", "Kubernetes", "Heroku"],
  },
];

const experienceData = [
  {
    title: "Software Developer - University of Mississippi",
    date: "May 2024 - Current",
  },
  {
    title: "Software Developer - Henry Schein",
    date: "Jul 2023 - May 2024",
  },
  {
    title: "Software Development Intern - Breathing.ai",
    date: "Feb 2023 - May 2023",
  },
];

const educationData = [
  {
    university: "Stevens Institute Of Technology",
    program: "Master Of Science in Computer Software Engineering",
  },
  {
    university: "Savitribai Phule Pune University",
    program: "Bachelor of Engineering in Civil Engineering",
  },
];

function Resume() {
  return (
    <div
      id="resume_c"
      className="font-sans text-base flex flex-col items-center justify-center min-h-screen py-12 px-4 sm:px-8 md:px-16 lg:px-32"
    >
      <section className="w-full max-w-3xl">
        {/* Skills Section */}
        <h2
          id="skills_c"
          className="text-2xl font-bold title-font m-5 underline text-center mb-2"
          style={{ color: "#213448" }}
        >
          My Stack
        </h2>
        <div className="w-full border-b border-gray-300 mb-6"></div>
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {skillsData.map((category) =>
            category.skills.map((skill) => (
              <span
                key={skill}
                className="px-6 py-3 border border-gray-400 rounded-xl text-lg text-gray-700 font-medium bg-white shadow-sm"
              >
                {skill}
              </span>
            ))
          )}
        </div>

        {/* Experience Section */}
        <h2
          id="jobinfo_c"
          className="text-2xl font-bold title-font m-5 underline text-center mb-2"
          style={{ color: "#213448" }}
        >
          Experience
        </h2>
        <div className="w-full border-b border-gray-300 mb-6"></div>
        <div className="flex flex-col items-center mb-12">
          <ol className="relative text-gray-500 dark:text-gray-400 w-full max-w-xl mx-auto">
            {experienceData.map((experience, index) => (
              <li key={index} className="mb-8 flex items-start">
                <div className="flex items-center justify-center w-10 h-10 bg-sky-200 rounded-full ring-4 ring-white dark:ring-gray-900 dark:bg-green-900 mr-4">
                  <span className="text-lg font-bold text-sky-700">
                    {index + 1}
                  </span>
                </div>
                <div className="ml-2 p-2">
                  <h3
                    className="text-lg font-semibold title-font mb-2 underline"
                    style={{ color: "#213448" }}
                  >
                    {experience.title}
                  </h3>
                  <p className="text-sm">{experience.date}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>

        {/* Education Section */}
        <h2
          id="education_c"
          className="text-2xl font-bold title-font m-5 underline text-center mb-2"
          style={{ color: "#213448" }}
        >
          Education
        </h2>
        <div className="w-full border-b border-gray-300 mb-6"></div>
        <div className="flex flex-col md:flex-row md:space-x-8 items-center justify-center mb-12">
          {educationData.map((education, index) => (
            <div
              key={index}
              className="flex flex-col items-center mb-8 md:mb-0"
            >
              <h2
                className="text-lg font-semibold title-font mb-2 underline text-center"
                style={{ color: "#213448" }}
              >
                {education.university}
              </h2>
              <p className="font-medium title-font text-center">
                {education.program}
              </p>
            </div>
          ))}
        </div>

        {/* Resume Download */}
        <div className="flex justify-center">
          <a
            href={resume}
            rel="noopener noreferrer"
            target="_blank"
            className="bg-transparent hover:bg-orange-600 text-sky-600 font-semibold hover:text-white p-2 border border-sky-600 hover:border-transparent rounded text-center"
          >
            Click here to Download Resume
          </a>
        </div>
      </section>
    </div>
  );
}

export default Resume;
